import { render, staticRenderFns } from "./editPermission.vue?vue&type=template&id=03f1cc28&"
import script from "./editPermission.vue?vue&type=script&lang=ts&"
export * from "./editPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports